import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { useForm } from 'react-hook-form';
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useEffect, useState } from "react";
import { Fetch } from "../../shared/Fetch";
import { JVInput } from "../../shared/JVInput";

import { ICompanyMastDropdown, IRemittanceDropdown } from "../../models/IDropdown";
import { JVDropdown } from "../../shared/JVDropdown";
import { IRemitance } from "../../models/Remitance";
import { EmptyRemitance } from "./EmptyRemitance";
import { JVDate } from "../../shared/JVDate";
import { format } from "date-fns";

const schema = yup.object({
     invoiceNo: yup.number().required("Invoice No. is required*").nullable(),
    received_Amount: yup.number().required("Received Amount is required*").typeError("Received Amount is required*"),
    deduction: yup.string().required("Deduction is required*").typeError("Deduction is required*"),
    reason: yup.string().required("Reason is required*").typeError("Reason is required*"),
    followUP: yup.string().required("Follow Up is required*").typeError("Follow Up is required*"),
    received_Date: yup.date().required("Received Date is required*").typeError("Date is required*"),
    vendor_InvoiceNo: yup.string().nullable(),
});

interface Iprops {
    singleData: IRemitance,
    open: boolean,
    hideDialog: () => void,
    toast: any,
    reload: boolean,
    setReload: (is: boolean) => void
}

export const Form = (props: Iprops) => {
    const [invoice, setInvoice] = useState<Array<IRemittanceDropdown>>();

    const { control, handleSubmit, formState: { errors }, reset,setValue } = useForm<IRemitance>({
        resolver: yupResolver(schema),
        defaultValues: props.singleData,
        shouldFocusError: false
    });

    // useEffect(() => {
    //     // if (props?.open && props.singleData?.received_Date) {
    //     //     const receivedDate = new Date(props?.singleData?.received_Date);
    //     //     props.singleData.received_Date = receivedDate;
    //     // }
    //     if (props?.singleData?.received_Date) {
    //         setValue("received_Date", new Date(props.singleData.received_Date));
    //     };
    //     reset(props.singleData);
    // }, [props.singleData]);


    useEffect(() => {
        if (props.open) {
            reset({
                ...props.singleData,
                received_Date: props.singleData?.received_Date ? new Date(props.singleData.received_Date) : null,
            });
            loadInvoices();
        }
    }, [props.singleData, props.open, reset]);


    const saveToDB = async (body: IRemitance) => {
        const method = props.singleData.remittance_ID ? "PUT" : "POST";
        const message = props.singleData.remittance_ID ? "Updated Successfully" : "Added Successfully";

        const response = await Fetch("tbl_Remittance", method, body, null, props.toast);

        if (response) {
            props.hideDialog();
            props.toast.current.show({ severity: 'success', detail: message, life: 3000 });
            props.setReload(!props.reload);
        }
    }

    const onHide = () => {
        props.hideDialog();
        reset(EmptyRemitance);
    }

    const loadInvoices = async () => {
        const response = await Fetch("Dropdown/invoices", "GET", null, null, null);
        if (response) {
            const data: Array<IRemittanceDropdown> = await response.json();
            const _data: Array<IRemittanceDropdown> = [];
            data.forEach(d => {
                _data.push({ invoice_ID: d.invoice_ID, invoiceNO: d.invoiceNO });
            })
            setInvoice(_data);
        }
    }

    useEffect(() => {
        loadInvoices();
    }, []);

    function onSubmit(data: IRemitance) {
        saveToDB(data);
    }

    return (
        <Dialog visible={props.open} style={{ width: '80vw' }} header="Add/Edit Remittance" modal className="p-fluid" onHide={onHide}>
            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
                {/* <JVInput required label="Invoice No" control={control} name="invoiceNo" error={errors.invoiceNo?.message} /> */}
                <JVDropdown required label="Invoice No" control={control} name="invoiceNo" options={invoice} optionLabel="invoiceNO" optionValue="invoice_ID" placeholder="Select Invoices" error={errors.invoiceNo?.message}/>
                <JVInput required label="Received Amount" control={control} name="received_Amount" />
                <JVDate label="Received Date" required control={control} name="received_Date" error={errors.received_Date?.message}  />
                <JVInput required label="Deduction" control={control} name="deduction" error={errors.deduction?.message} />
                <JVInput required label="Reason" control={control} name="reason" error={errors.reason?.message} />
                <JVInput required label="Follow UP" control={control} name="followUP" error={errors.followUP?.message} />
                <JVInput label="Vendor Invoice No." control={control} name="vendor_InvoiceNo" />
                <div className="col-12 md:col-12">
                    <Button className="field col-12 md:col-6" label="SAVE" type="submit"></Button>
                    <Button className="field col-12 md:col-6 p-button-outlined" label="CLOSE" onClick={onHide} type="button"></Button>
                </div>
            </form>
        </Dialog>
    );
}

